// Central content for Matlock Advisory Group site
export const CONTACT = {
  phone: "501-993-3139",
  email: "Bill@MatlockAdvisoryGroup.com",
  // TODO: Replace with real office address
  address: "Dallas, Texas",
  // TODO: Replace with real scheduling link (e.g., Calendly)
  schedulingLink: "#contact",
  socials: {
    // TODO: Replace with real LinkedIn profile URL
    linkedin: "#",
    instagram: "https://instagram.com/MatlockAdvisoryGroup",
    facebook: "https://facebook.com/MatlockAdvisoryGroup"
  }
};

export const LOGO_URL = "/matlock-logo-light.png";

export const IMAGES = {
  hero:
    "https://images.unsplash.com/photo-1619218070141-bcfeb8b93074?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  crna:
    "https://images.unsplash.com/photo-1758691463000-08b98131daf3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  abstract:
    "https://images.unsplash.com/photo-1646473599758-b85396cda199?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
};

export const HEADSHOTS = {
  bill: "/bill-matlock.jpg",
  hudson:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_healthcare-cfo-hub/artifacts/g93odlzw_D514DAAC-8D34-4CF6-BBB2-A8B2E41775CC.png"
};

export const FOS_STEPS = [
  { n: "01", title: "Income", desc: "We map every stream of your 1099 income so nothing is a surprise at year end." },
  { n: "02", title: "Taxes", desc: "Federal and quarterly obligations are estimated and coordinated on a rhythm." },
  { n: "03", title: "Business Cash Flow", desc: "Business and personal accounts are organized into a clear, repeatable flow." },
  { n: "04", title: "Retirement Contributions", desc: "We surface the retirement vehicles available to your entity structure." },
  { n: "05", title: "Bookkeeping", desc: "Clean books that stay current, coordinated with your bookkeeper or ours." },
  { n: "06", title: "Monthly Reporting", desc: "A simple monthly picture of where your money is and where it is going." },
  { n: "07", title: "Quarterly Planning", desc: "Forward-looking meetings to plan taxes and decisions before deadlines." },
  { n: "08", title: "Long-Term Decisions", desc: "Every choice is made with your long-term financial direction in mind." }
];

export const SERVICES = [
  { title: "Fractional CFO Services", desc: "High-level financial leadership for your practice or contracting business, without a full-time hire." },
  { title: "Cash Flow Planning", desc: "A clear system for what comes in, what to set aside, and what is safe to use." },
  { title: "Tax Planning Coordination", desc: "We coordinate federal and quarterly tax planning alongside your tax professional." },
  { title: "Retirement Contribution Planning", desc: "Understand the retirement options available to your income and entity structure." },
  { title: "Monthly Financial Reporting", desc: "Consistent, readable reports so you always know where you stand." },
  { title: "Bookkeeping Oversight", desc: "Oversight and coordination that keeps your books accurate and current." },
  { title: "Business Consulting", desc: "Guidance on entity structure, spending, and the financial side of growth." },
  { title: "Financial Organization for 1099s", desc: "Bring scattered accounts and decisions into one coordinated operating system." }
];

export const SERVE = [
  { title: "CRNAs", desc: "The professionals at the heart of our practice — independent nurse anesthetists." },
  { title: "Anesthesiology Professionals", desc: "Anesthesiologists and anesthesia contractors managing significant 1099 income." },
  { title: "Physicians", desc: "Doctors operating as independent contractors or through their own entity." },
  { title: "Advanced Practice Providers", desc: "NPs, PAs, and CRNAs building income across contracts and locations." },
  { title: "Traveling Medical Professionals", desc: "Providers working across multiple states with variable, mobile income." },
  { title: "Healthcare Contractors", desc: "Other high-income medical professionals earning through 1099 arrangements." }
];

export const CHALLENGES = [
  "Tax planning",
  "Payroll optimization",
  "S-Corp structure analysis",
  "Retirement contribution strategy & optimization",
  "Bookkeeping & financial organization",
  "Improve monthly cash flow",
  "Maintain clean, audit-ready financial records",
  "Reduce unnecessary tax liability"
];

export const PROCESS = [
  { n: "01", title: "Introductory Consultation", desc: "A relaxed conversation to understand your situation and answer your questions." },
  { n: "02", title: "Financial & Business Review", desc: "We review your income, entity, accounts, and current financial picture." },
  { n: "03", title: "Operating System Design", desc: "We design a Financial Operating System personalized to you." },
  { n: "04", title: "Implementation & Coordination", desc: "We put the system in place and coordinate with your other professionals." },
  { n: "05", title: "Monthly Reporting", desc: "You receive clear monthly reporting on your finances." },
  { n: "06", title: "Quarterly Planning", desc: "We meet each quarter to plan ahead of taxes and key decisions." },
  { n: "07", title: "Ongoing Consulting", desc: "We remain a steady partner as your career and business evolve." }
];

export const MARQUEE = [
  "Income Optimization",
  "Quarterly Tax Planning",
  "Retirement Strategy",
  "Cash Flow",
  "Monthly Reporting",
  "Bookkeeping Oversight"
];

export const INCOME_RANGES = [
  "Under $250,000",
  "$250,000 – $500,000",
  "$500,000 – $750,000",
  "$750,000 – $1,000,000",
  "Over $1,000,000"
];

export const EMPLOYMENT_STRUCTURES = [
  "Sole proprietor / 1099",
  "Single-member LLC",
  "PLLC",
  "S Corporation",
  "Not sure yet"
];

export const CONTACT_METHODS = ["Email", "Phone call", "Text message"];

export const LEAD_SOURCES = [
  "Referral from a colleague",
  "Referral from a current client",
  "A CRNA / medical professional group",
  "Google or web search",
  "Social media",
  "Conference or event",
  "Other"
];

export const DISCLAIMER =
  "Matlock Advisory Group provides financial consulting, business financial management, and financial coordination services. Information presented on this website is for general informational purposes and should not be considered individualized tax, legal, accounting, securities, or investment advice. Clients should consult appropriately licensed professionals regarding their individual circumstances.";
